import React from 'react';
import {Form, Edit, Textarea, Flex, Suggestions, List} from 'components';
import {useNamedSelector} from 'helpers';

export function AskYourself() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'values-inquiry-1' })}>
      <List tiny-gutter>
        <List.Title>What is truly important to me?</List.Title>
        <Flex even stack>
          <Edit name="1" Suggestions={Suggestions.Values} />
          <Edit name="2" Suggestions={Suggestions.Values} />
        </Flex>
        <List.Title>What do I really believe in and stand for?</List.Title>
        <Flex even stack>
          <Edit name="3" Suggestions={Suggestions.Values} />
          <Edit name="4" Suggestions={Suggestions.Values} />
        </Flex>
        <List.Title>What will I never be willing to let go or live without(e.g. love, integrity,etc.)?</List.Title>
        <Flex even stack>
          <Edit name="5" Suggestions={Suggestions.Values} />
          <Edit name="6" Suggestions={Suggestions.Values} />
        </Flex>
        <List.Title>What values have the greatest effect on my life?</List.Title>
        <Flex even stack>
          <Edit name="7" Suggestions={Suggestions.Values} />
          <Edit name="8" Suggestions={Suggestions.Values} />
        </Flex>
        <List.Title>Think of people you admire; your heroes and role models. What are their most obvious qualities, and what values do they live by?</List.Title>
        <Edit name="9" Suggestions={Suggestions.Values} />
        <Edit name="10" Suggestions={Suggestions.Values} />
        <Edit name="11" Suggestions={Suggestions.Values} />
        <List.Title>What would it be like to live by the same values?</List.Title>
        <Textarea single name="13" />
        <List.Title>Describe your picture of an ideal person, the person you would most want to be if you had not limitations.</List.Title>
        <Textarea single name="14" />
        <p className="medium-spacing">
          Look at all the values you have identified and ask yourself: "Am I already living by those values, or are those the values I want to live by or believe I should live by?" Your true values are those that you live by daily or are willing to commit to live by consistently.
        </p>
      </List>
    </Form>
  );
}
